import { FontAwesomeIcon } from 'module/ui/components/atoms/icon/icon';
import { faDownload, faFile } from '@fortawesome/pro-regular-svg-icons';
import { Button } from '@rocketlane/ui';
import React, { ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';

interface UnsupportedFileFallbackProps {
  fileName: string;
  onDownload: () => void;
  message: ReactNode;
  hint: ReactNode;
}

export const UnsupportedFileFallback: React.FC<
  UnsupportedFileFallbackProps
> = ({ fileName, onDownload, message, hint }) => (
  <div
    style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100%',
      color: '#666',
      textAlign: 'center',
      padding: '20px',
    }}
  >
    <div style={{ textAlign: 'center', marginBottom: '20px' }}>
      <FontAwesomeIcon
        icon={faFile}
        size="3x"
        style={{ color: '#1890ff', marginBottom: '16px' }}
      />
      <h3 style={{ margin: '0 0 8px 0', color: '#1d1d1f' }}>{fileName}</h3>
      <p style={{ margin: '0 0 16px 0', color: '#666' }}>{message}</p>
      <p
        style={{
          margin: '0 0 24px 0',
          color: '#999',
          fontSize: '14px',
        }}
      >
        {hint}
      </p>
    </div>
    <Button
      variant="primary"
      size="large"
      onClick={onDownload}
      leftIcon={<FontAwesomeIcon icon={faDownload} size={12} />}
    >
      <FormattedMessage id="knowledge_base.file_viewer.download_file" />
    </Button>
  </div>
);
